import { Cache } from 'aws-amplify';
import { addMinutes } from 'date-fns';
import { getDataSourceOverride } from 'src/utils/dataSource';

// Keys are prefixed with the data-source override (test only) so cached responses from
// one backend are never shown after switching to another.
const scopedKey = (key: string) => {
  const override = getDataSourceOverride();
  return override === 'default' ? key : `src=${override}:${key}`;
};

export const storeInCache = <T>(
  key: string,
  value: T,
  expiration: Date = addMinutes(new Date(), 4) // 4 min cache expiry time
) => {
  Cache.setItem(scopedKey(key), value, { expires: expiration.getTime() });
};
export const getCache = (key: string) => {
  return Cache.getItem(scopedKey(key));
};
